/**
 * Runtime environment access.
 *
 * Create React App bakes `REACT_APP_*` variables into the bundle at build time,
 * which would force a separate image per environment. To allow a single image to
 * be reused across environments, the container generates `public/env-config.js`
 * at startup (see docker-entrypoint.sh), exposing values on `window._env_`.
 *
 * `getEnv` prefers the runtime value and falls back to `process.env` so that
 * local development (via env-cmd) keeps working unchanged.
 */

type RuntimeEnv = Record<string, string | undefined>;

declare global {
  interface Window {
    _env_?: RuntimeEnv;
  }
}

export const getEnv = (key: string): string | undefined => {
  const runtimeValue =
    typeof window !== "undefined" ? window._env_?.[key] : undefined;

  if (runtimeValue !== undefined && runtimeValue !== "") {
    return runtimeValue;
  }

  return process.env[key];
};
